import React from "react";
import MarketListPanel from "@features/Market/MainComponents/MarketListPanel";

const MarketSelectTab = ({ handleClose }) => (
  <MarketListPanel variant="header" onNavigate={handleClose} />
);

export default MarketSelectTab;
